<template>
<div class="progress">
    <div class="progress__wrap c c--content--pad pad--h r">
        <div class="progress__count type--h5--default">
            Step {{ current }} of {{ max }}
        </div>
        <div class="progress__bar">
            <div class="progress__bar__nodes">
                <div v-for="i in Number(max)" :key="i" class="progress__bar__nodes__node" :class="{ 'progress__bar__nodes__node--filled': i <= current }">
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        countMax: String,
        countCurrent: String,
    },
    computed: {
        max() {
            return parseInt(this.countMax);
        },
        current() {
            return parseInt(this.countCurrent);
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@s/_mixins.scss";
@import "@s/_vars.scss";

.progress {
    padding-bottom: rem(40px);
}

.progress__wrap {
    gap: rem(12px);
    align-items: center;
    justify-content: center;
}

.progress__count {
    display: flex;
    text-align: center;
}

.progress__bar {
    width: 100%;
}

.progress__bar__nodes {

    width: 100%;
    display: flex;
    gap: rem(5.6px);
}

.progress__bar__nodes__node {
    display: inline-flex;
    height: rem(10px);
    width: 100%;
    border-radius: rem(18px);
    background-color: var(--color-sp-jade);
    opacity: 0.1;
    transition: all 0.35s;
    &--filled {
        opacity: 1;
    }
}
</style>